/*
 * Copyright (c) 2024 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
import Cookies from 'js-cookie';

import HUBUtils from 'HUB/satellites/utils/HUBUtils';

 /**
 * HUB framework consent utilities
 * @class HUBCookiesConsent
 * @author Vincent BONESTEVE
 */
export default class HUBCookiesConsent {
  static CONSENT_DURATION_DAYS = 30;
  /**
   * Check if a valid consent was given
   * @static
   */
  static hasActiveConsent(){
    let consentTime = Cookies.get('cst');
    if (!HUBUtils.isEmpty(consentTime)){
      let now = new Date().getTime();
      let delta = (now - consentTime)/1000;
      if (delta <= (HUBCookiesConsent.CONSENT_DURATION_DAYS*24*60*60)){
        return true;
      }
    }
    return false;
  }

  /**
   * Record consent
   * @static
   */
  static recordConsent(){
    Cookies.set('cst', new Date().getTime(),{ expires: HUBCookiesConsent.CONSENT_DURATION_DAYS });
  }

  /**
   * Reject consent
   * @static
   */
  static rejectConsent(){
    Cookies.remove('cst');
  }
}
